import { FuseNavigation } from '@fuse/types';

const adminNavigation: FuseNavigation[] = [

    /*
   {
       id       : 'dashboard',
       title    : 'Dashboard',
       type     : 'item',
       url      : '/dashboard',
       icon     : 'dashboard',

   },
    */
    {

        id       : 'nomenclatures',
        title    : 'Nomenclatoare',
        type     : 'group',
        icon     : 'library_books',
        children : [
            {
                id       : 'nomenclatures.users',
                title    : 'Utilizatori',
                type     : 'item',
                icon     : 'supervisor_account',
                url      : '/nomenclatures/users',
            },

            {
                id       : 'nomenclatures.jobTypes',
                title    : 'Tip-uri job',
                type     : 'item',
                icon     : 'library_books',
                url      : '/nomenclatures/job-types',
            },




        ]
    },
    {
        id       : 'jobs',
        title    : 'Job-uri',
        type     : 'group',
        icon     : 'assignment',
        children : [
            {
                id       : 'list',
                title    : 'Lista job-uri',
                type     : 'item',
                icon     : 'vertical_split',
                url      : '/jobs/list',
            },
        ]
    },
    {
        id       : 'questionnaires',
        title    : 'Consiliere',
        type     : 'group',
        icon: 'contact_support',
        children : [
            {
                id       : 'create',
                title    : 'Lista chestionare',
                type     : 'item',
                icon     : 'question_answer',
                url      : '/questionnaires/list',
            },
            {
                id       : 'formTesting',
                title    : 'Chestionar nou',
                type     : 'item',
                icon     : 'quickreply',
                url      : '/questionnaires/create',
            }
        ]
    },
    {
        id       : 'user.profile',
        title    : 'Setari',
        type     : 'item',
        url      : '/auth/user-settings',
        icon     : 'settings',

    }

];

const angajatorNavigation: FuseNavigation[] = [

    /*
 {
     id       : 'dashboard',
     title    : 'Dashboard',
     type     : 'item',
     url      : '/dashboard',
     icon     : 'dashboard',

 },
  */
    {
        id       : 'jobs',
        title    : 'Job-uri',
        type     : 'group',
        icon     : 'assignment',
        children : [
            {
                id       : 'list',
                title    : 'Lista job-uri',
                type     : 'item',
                icon     : 'vertical_split',
                url      : '/jobs/list',
            },
        ]
    },

    {
        id       : 'user.profile',
        title    : 'Setari',
        type     : 'item',
        url      : '/auth/user-settings',
        icon     : 'settings',

    },

];

const studentNavigation: FuseNavigation[] = [
    /*
  {
      id       : 'dashboard',
      title    : 'Dashboard',
      type     : 'item',
      url      : '/dashboard',
      icon     : 'dashboard',

  },
   */
    {
        id       : 'user.profile',
        title    : 'Setari',
        type     : 'item',
        url      : '/auth/user-settings',
        icon     : 'settings',

    },

    {
        id       : 'jobs',
        title    : 'Job-uri',
        type     : 'group',
        icon     : 'assignment',
        children : [
            {
                id       : 'list',
                title    : 'Lista job-uri',
                type     : 'item',
                icon     : 'vertical_split',
                url      : '/jobs/list',
            },
        ]
    },

    {
        id       : 'questionnaires',
        title    : 'Consiliere',
        type     : 'group',
        icon: 'contact_support',
        children : [
            {
                id       : 'create',
                title    : 'Lista chestionare',
                type     : 'item',
                icon     : 'question_answer',
                url      : '/questionnaires/list',
            }
        ]
    },

];

const universitateNavigation: FuseNavigation[] = [
    /*
    {
        id       : 'dashboard',
        title    : 'Dashboard',
        type     : 'item',
        url      : '/dashboard',
        icon     : 'dashboard',

    },
     */

    {
        id       : 'user.profile',
        title    : 'Setari',
        type     : 'item',
        url      : '/auth/user-settings',
        icon     : 'settings',

    },

    {
        id       : 'jobs',
        title    : 'Job-uri',
        type     : 'group',
        icon     : 'assignment',
        children : [
            {
                id       : 'list',
                title    : 'Lista job-uri',
                type     : 'item',
                icon     : 'vertical_split',
                url      : '/jobs/list',
            },
        ]
    },

];

function getNavigation(){
    
    const profile = localStorage.getItem('user_entityType');

    if (profile === 'admin' ){
        return adminNavigation;
    }

    if (profile === 'angajator' ){
        return angajatorNavigation;
    }

    if (profile === 'student'){
        return studentNavigation;
    }

    if (profile === 'universitate'){
        return universitateNavigation;
    }

    return [];

}

export const navigation: FuseNavigation[] = getNavigation();

/*{
        id       : 'applications',
        title    : 'Applications',
        translate: 'NAV.APPLICATIONS',
        type     : 'group',
        children : [
            {
                id       : 'sample',
                title    : 'Sample',
                translate: 'NAV.SAMPLE.TITLE',
                type     : 'item',
                icon     : 'email',
                url      : '/sample',
                badge    : {
                    title    : '25',
                    translate: 'NAV.SAMPLE.BADGE',
                    bg       : '#F44336',
                    fg       : '#FFFFFF'
                }
            },
            {
                id       : 'formTesting',
                title    : 'FormTesting',
                translate: 'NAV.FORMTESTING.TITLE',
                type     : 'item',
                icon     : 'email',
                url      : '/form-testing'
            }
        ]
    }

 */
